module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBasic.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '60vw'
    }),
    attrs: {
      "header": "Employee Position",
      "visible": _vm.displayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-6"
        }, [_c('Button', {
          staticClass: "p-button-raised",
          attrs: {
            "label": "Save",
            "icon": "pi pi-save"
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })], 1)])]
      },
      proxy: true
    }])
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "reportingMethod"
    }
  }, [_vm._v("Reporting Method ")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "reportingMethod",
      "optionLabel": "name",
      "options": _vm.reportingMethodList,
      "placeholder": "--Select--"
    },
    model: {
      value: (_vm.reportingMethod),
      callback: function($$v) {
        _vm.reportingMethod = $$v
      },
      expression: "reportingMethod"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('DataTable', {
    attrs: {
      "value": _vm.employeeList,
      "dataKey": "id",
      "paginator": true,
      "rows": 8,
      "selection": _vm.selectedEmployee,
      "filters": _vm.filters,
      "selectionMode": "multiple"
    },
    on: {
      "update:selection": function($event) {
        _vm.selectedEmployee = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("\n              No customers found.\n            ")]
      },
      proxy: true
    }])
  }, [_c('Column', {
    attrs: {
      "header": "Employee Id",
      "field": "employeeId"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['value']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'value', $$v)
            },
            expression: "filters['value']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Name",
      "field": "employeeName"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['value']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'value', $$v)
            },
            expression: "filters['value']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Employee Address"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Group"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Branch Office"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Department"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('DataTable', {
    attrs: {
      "value": _vm.employeeList,
      "dataKey": "id",
      "paginator": true,
      "rows": 8,
      "filters": _vm.filters,
      "selectionMode": "multiple"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('span', [_vm._v("Assigned Supervisors")])]
      },
      proxy: true
    }, {
      key: "empty",
      fn: function() {
        return [_vm._v("\n      No records found.\n    ")]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Name",
      "field": "employeeName"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Reporting Method"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Actions"
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "p-mt-5 p-mb-5"
  }), _vm._v(" "), _c('DataTable', {
    attrs: {
      "value": _vm.employeeList,
      "dataKey": "id",
      "paginator": true,
      "rows": 8,
      "filters": _vm.filters,
      "selectionMode": "multiple"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('span', [_vm._v("Assigned Subordinates")])]
      },
      proxy: true
    }, {
      key: "empty",
      fn: function() {
        return [_vm._v("\n      No records found.\n    ")]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Name",
      "field": "employeeName"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Reporting Method"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Actions"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d03df12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/Employee/report-to.vue
// module id = 2358
// module chunks = 0